import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { CentroService } from 'src/app/services/centro.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';
import { LoginService } from 'src/app/services/login.service';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';

@Component({
  selector: 'app-documentos-adic-centro',
  templateUrl: './documentos-adic-centro.component.html',
  styleUrls: ['./documentos-adic-centro.component.scss'],
})
export class DocumentosAdicCentroComponent implements OnInit {
  datosDocumento: any;
  nameDocumento: any;
  url: any;
  userLog:any
  caducidad:any
  docAdicional: any
  centrosCliente:any =[]
  documentos:any =[]

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public info: {
      id: string;
      nAuth: any;
      periocidad: any;
    },
    private formBuilder: FormBuilder,
    private uploadService: UploadDocumentosService,
    private apollo: Apollo,
    private docAdicionalService: DocAdicionalService,
    private loginService: LoginService,
    private clienteService: ClienteService
  ) {
    this.buildForm();
    this.userLog = loginService.getUserData()
  }

  ngOnInit(): void {
 this.getCentrosByCliente()
 this.getAllDocAdicional()
 console.log(this.info.nAuth.numArchivo);
 
  }

  setPeriodo(){
    switch (this.info.nAuth.periocidad) {
      case 'Mensual':
        this.caducidad = moment(this.datosDocumento.value.fechaValidez).add('days', 30)
        break;
      case 'Trimestral':
        this.caducidad = moment(this.datosDocumento.value.fechaValidez).add('days', 90)
        break;
      case 'Semestral':
        this.caducidad = moment(this.datosDocumento.value.fechaValidez).add('days', 180)
        break;
      case 'Anual':
        this.caducidad = moment(this.datosDocumento.value.fechaValidez).add('days', 365)
        break;
      default:
        break;
    }
    
  }

  getAllDocAdicional(){
    this.apollo.query<any>({
      query: this.docAdicionalService.getAllDocumentos()
    })
    .subscribe(({data,errors})=>{
      this.documentos = data.documentosAdicionals.filter((doc:any)=> doc.nombre)

      console.log(this.documentos);
      
      
    })
  }

  
  dropped(files: any) {
    this.uploadService.dropped(files).subscribe((res: any) => {
      this.nameDocumento = res[0].name;
      this.url = res[0].url;
    });
  }

  private buildForm() {
    this.datosDocumento = this.formBuilder.group({
      nombre: [''],
      fechaValidez: ['', [Validators.required]],

    });
  }

 

  uploadDocumento(){
    this.setPeriodo()
    if (this.info.nAuth.periocidad != 'No caduca') {
      this.apollo.mutate({
        mutation: this.docAdicionalService.addDocumento(),
        variables: {
          "input": {
            "data": {
              "contratista": this.userLog.contratista.id,
              "nombreArchivo": this.info.nAuth.nombreArchivo,
              "cliente": this.info.nAuth.cliente.id,
              "periocidad": this.info.nAuth.periocidad,
              "centros": this.info.id,
              "fechaValidez": this.datosDocumento.value.fechaValidez,
              "fechaCaducidad": this.caducidad,
              "tipo": "pendiente",
              "url": this.url,
              "subidoPor": this.userLog.id,
              "nombre": this.nameDocumento,
              "validado":false,
              "numArchivo": this.info.nAuth.numArchivo
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("ADD Ok", data, errors)
        /*   this.updateDocumentoAdicional() */
        location.reload()
        }, (error) => {
          console.log('error',error)
        })
    }else{
      this.apollo.mutate({
        mutation: this.docAdicionalService.addDocumento(),
        variables: {
          "input": {
            "data": {
              "contratista": this.userLog.contratista.id,
              "nombreArchivo": this.info.nAuth.nombreArchivo,
              "cliente": this.info.nAuth.cliente.id,
              "periocidad": 'No caduca',
              "centros": this.info.id,
              "noCaduca": true,
              "tipo": "pendiente",
              "url": this.url,
              "subidoPor": this.userLog.id,
              "nombre": this.nameDocumento,
              "validado":false,
              "numArchivo": this.info.nAuth.numArchivo
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("ADD Ok", data, errors)
          location.reload()
   /*        this.updateDocumentoAdicional() */
        }, (error) => {
          console.log('error',error)
        })
    }
  }
  updateDocumentoAdicional(){

    this.apollo.mutate({
      mutation: this.docAdicionalService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.info.nAuth.id,
          },
          "data": {
            "centros": this.centrosCliente,
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }
  

  getCentrosByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),

      variables: {
        "id": this.info.nAuth.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data);
        
        data.cliente.centros.forEach((centro:any) => {
          if (centro.id != this.info.id) {
            this.centrosCliente.push(centro.id)
          }
         
         
        }); 
        console.log(this.centrosCliente);
      })
  }

}
